import { LoadingButton } from '@mui/lab';
import { Container, ImageListItem, Typography } from '@mui/material';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import IMG from '~/assets/images/man_bike.png';
import useStore, { storeState } from '~/store';
import { getErrorMessage, logErrorWithContext } from '~/utils/errorHandler';
import * as styles from './styles';

export default function HelpZipcodePage() {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const { contractAsyncDownload, contract_id } = useStore((store) => ({
    contractAsyncDownload: store.contractAsyncDownload,
    contract_id: store.contract_id
  }));

  const handleDownload = async () => {
    if (contract_id) {
      setLoading(true);
      try {
        const orgParam = searchParams.get('org');
        await contractAsyncDownload(String(contract_id), orgParam ?? undefined);
        setLoading(false);
      } catch (error: any) {
        setLoading(false);

        // Log do erro com contexto
        logErrorWithContext(error, 'contract_step6_download', {
          contractId: contract_id
        });

        // Usar o sistema unificado de tratamento de erros
        const errorResponse = getErrorMessage(error);
        storeState.addToast(errorResponse);
      }
    } else {
      storeState.addToast({
        title: 'Não foi possível realizar o download',
        message: 'Nenhum contrato foi encontrado para realizar o download',
        type: 'warning'
      });
    }
  };

  return (
    <Container maxWidth="lg" sx={styles.container}>
      <ImageListItem sx={styles.imgContainer}>
        <img src={IMG} alt="" style={styles.imgStyle} />
      </ImageListItem>
      <Typography variant="h3" sx={styles.title}>
        Quase lá!
      </Typography>
      <Typography variant="h6" sx={styles.description}>
        Vamos analisar a sua documentação e te avisaremos em breve!
      </Typography>
      <LoadingButton
        data-testid="contract-download-btn"
        variant="contained"
        sx={styles.buttonDownload}
        onClick={handleDownload}
        loading={loading}
      >
        Baixar contrato
      </LoadingButton>
    </Container>
  );
}
